export default __webpack_public_path__ + "static/media/peak-logo-top-left.a22f48b5.png";